module.exports = __webpack_public_path__ + "e84ed9a80dc6e66d730d79fb1531aa76.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Dolphin2.jpg
// module id = 3271
// module chunks = 0